import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { QUERY_KEYS } from 'src/constants'
import { stylesService } from 'src/services'

export const useAccountStyles = () => {
  const { productId, simpleProductId, accountId } = useParams()

  const productKey = simpleProductId || productId || null
  const accountKey = accountId || null
  const hasSource = Boolean(productKey || accountKey)

  const queryResult = useQuery(
    [QUERY_KEYS.GET_ACCOUNT_STYLES, productKey, accountKey],
    () =>
      stylesService.getAccountStyles({
        productId: productKey,
        accountId: productKey ? null : accountKey,
      }),
    {
      keepPreviousData: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      enabled: hasSource,
    },
  )

  return {
    ...queryResult,
    data: hasSource ? queryResult.data : undefined,
  }
}
